import React, { Component, Fragment } from 'react';
import nl2br from 'react-nl2br';
import Measure from 'react-measure';
import {
  Row,
  Col,
} from 'reactstrap';
import Link from 'react-router-dom/Link';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import bannerDesktopEN from '../../assets/banner-en.jpg';
import bannerDesktopJP from '../../assets/banner-jp.jpg';
import bannerMobileEN from '../../assets/mobile-banner-en.jpg';
import bannerMobileJP from '../../assets/mobile-banner-jp.jpg';
import workshop from '../../assets/workshop.jpg';
import exhibition from '../../assets/exhibition.jpg';
import fleaMarket from '../../assets/flea-market.jpg';

const Container = styled.div`
  @media (min-width: 576px) {
    margin-top: 3rem;
  }
`;

const Carousel = styled.div``;

const HeaderImage = styled.img`
  width: 100%;
  height: auto;
  margin-bottom: 3rem;
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: 1.25rem;
  font-size: 2rem;
`;

const Description = styled.p`
  text-align: center;
  margin-bottom: 4rem;
`;

const SubPageTitle = styled.h2`
  text-align: center;
  margin-bottom: 1.25rem;
  font-size: 2rem;
  line-height: 1.2 !important;
`;

const SubPageDescription = styled.h4`
  text-align: center;
  font-size: 1.25rem;
  margin-top: 0px;
  margin-bottom: 1.75rem;
  line-height: 1.2 !important;
`;

class Home extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
  }

  state = {
    dimensions: {
      width: -1,
    },
  }

  componentDidMount() {
    // eslint-disable-next-line no-undef
    window.scrollTo(0, 0);
  }

  render() {
    const { intl } = this.props;
    const { dimensions: { width } } = this.state;

    return (
      <Fragment>
        <Carousel className="carousel slide">
          {width <= 575.98 ? (
            <HeaderImage src={intl.locale === 'ja' ? bannerMobileJP : bannerMobileEN} />
          ) : (
            <HeaderImage src={intl.locale === 'ja' ? bannerDesktopJP : bannerDesktopEN} />
          )}
        </Carousel>
        <Measure
          bounds
          onResize={(contentRect) => {
            this.setState({ dimensions: contentRect.bounds });
          }}
        >
          {({ measureRef }) => (
            <Container ref={measureRef} className="marketing container">
              <Row className="featurette">
                <Col md={{ size: 8, offset: 2 }}>
                  <Title className="featurette-heading">
                    {nl2br(intl.formatMessage({
                      id: 'Home.Section1.Title',
                    }))}
                  </Title>
                  <Description className="lead">
                    {nl2br(intl.formatMessage({
                      id: 'Home.Section1.SubTitle',
                    }))}
                  </Description>
                </Col>
              </Row>
              <Row>
                <Col md={{ size: 10, offset: 1 }}>
                  <hr />
                  <Row className="mt-5 mb-5">
                    <Col md="6" className="d-flex flex-column justify-content-center">
                      <SubPageTitle className="featurette-heading">
                        {nl2br(intl.formatMessage({
                          id: 'Workshop.Title',
                        }))}
                      </SubPageTitle>
                      <SubPageDescription>
                        {nl2br(intl.formatMessage({
                          id: 'Workshop.SubTitle',
                        }))}
                      </SubPageDescription>
                      <Link
                        to="/workshop"
                        className="btn btn-sm btn-primary mb-4"
                        style={{
                          width: 200,
                          alignSelf: 'center',
                        }}
                      >
                        <FormattedMessage id="Home.ReadMoreButton" />
                      </Link>
                    </Col>
                    <Col md="6">
                      <Link to="/workshop">
                        <img
                          src={workshop}
                          alt="workshop"
                          className="img-fluid rounded"
                        />
                      </Link>
                    </Col>
                  </Row>
                  <hr />
                  <Row className="mt-5 mb-5">
                    <Col md="6">
                      <Link to="/exhibition">
                        <img
                          src={exhibition}
                          alt="exhibition"
                          className="img-fluid rounded mb-4"
                        />
                      </Link>
                    </Col>
                    <Col md="6" className="d-flex flex-column justify-content-center">
                      <SubPageTitle className="featurette-heading">
                        {nl2br(intl.formatMessage({
                          id: 'Exhibition.Title',
                        }))}
                      </SubPageTitle>
                      <SubPageDescription>
                        {nl2br(intl.formatMessage({
                          id: 'Exhibition.SubTitle',
                        }))}
                      </SubPageDescription>
                      <Link
                        to="/exhibition"
                        className="btn btn-sm btn-primary"
                        style={{
                          width: 200,
                          alignSelf: 'center',
                        }}
                      >
                        <FormattedMessage id="Home.ReadMoreButton" />
                      </Link>
                    </Col>
                  </Row>
                  <hr />
                  <Row className="mt-5">
                    <Col md="6" className="d-flex flex-column justify-content-center">
                      <SubPageTitle className="featurette-heading">
                        {nl2br(intl.formatMessage({
                          id: 'FleaMarket.Title',
                        }))}
                      </SubPageTitle>
                      <SubPageDescription>
                        {nl2br(intl.formatMessage({
                          id: 'FleaMarket.SubTitle',
                        }))}
                      </SubPageDescription>
                      <Link
                        to="/flea-market"
                        className="btn btn-sm btn-primary mb-4"
                        style={{
                          width: 200,
                          alignSelf: 'center',
                        }}
                      >
                        <FormattedMessage id="Home.ReadMoreButton" />
                      </Link>
                    </Col>
                    <Col md="6">
                      <Link to="/flea-market">
                        <img
                          src={fleaMarket}
                          alt="workshop"
                          className="img-fluid rounded"
                        />
                      </Link>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          )}
        </Measure>
      </Fragment>
    );
  }
}

export default injectIntl(Home);
